import React from "react";
import { bool, oneOf, string } from "prop-types";

import componentSizes from "../../../../constants/componentSizes";
import * as S from "./styled";

const TextInput = React.forwardRef((props, ref) => (
  <S.Input ref={ref} {...props} />
));

TextInput.displayName = "TextInput";

TextInput.propTypes = {
  isValid: bool,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG]),
  type: string
};

TextInput.defaultProps = {
  isValid: true,
  size: componentSizes.MD,
  type: "text"
};

export default TextInput;
